import React from 'react';
import { SxProps, Theme } from '@mui/material';

const gradient = 'linear-gradient(100.09deg, #4054B2 0%, #6EC1E4 100%)';

export const badgeContainer: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '4px 12px',
  borderRadius: '20px',
  background: 'transparent',
  whiteSpace: 'nowrap',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: 'inherit',
    padding: '2px',
    background: gradient,
    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
    pointerEvents: 'none',
  },
};

export const badgeText: SxProps<Theme> = {
  fontFamily: 'Ubuntu, Open Sans, sans-serif',
  fontWeight: 700,
  fontSize: '13px',
  letterSpacing: '0.5px',
  background: gradient,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  lineHeight: 1,
};

export const badgeIconSvg: React.CSSProperties = {
  flexShrink: 0,
  display: 'block',
};

export const practitionerWrapper: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};
